<template>
  <div class="content">
    <div class="page-inner">
      <h1 class="mb-4">
        {{ $t('extra_tools') }}
      </h1>

      <select v-model="categoryFilter" class="form-control" v-if="beta">
        <option value="">{{ $t('all_categories') }}</option>
        <option value="marketing">Marketing and Promotion</option>
        <option value="audio">Audio and Production</option>
        <option value="video">Video</option>
        <option value="tools">Tools</option>
        <option value="forms">{{ $t('forms') }}</option>
      </select>

      <!-- <div class="mt-3 mb-3 text-center" v-if="!user.subscription">
        <ins class="adsbygoogle"
          style="display:block"
          data-ad-client="ca-pub-8326584585992829"
          data-ad-slot="1178271480"
          data-ad-format="auto"
          data-full-width-responsive="true"></ins>
      </div> -->

      <div class="row mt-3" v-if="beta">
        <div class="col-md-6" v-for="(service, index) in filteredServices" v-bind:key="`service_${index}`" v-show="!service.admin || (service.admin && user.role === 'admin')">
          <router-link class="card" :to="service.url">
            <div class="card-body p-3 pos-relative">
              <span v-if="service.new" class="new badge badge-danger text-capitalize">
                {{ $t('new') }}
              </span>
              <div class="row mb-2">
                <div class="col-4">
                  <img :src="service.image" :aylt="service.name" class="img-fluid">
                  <div class="text-muted mt-3 small">
                    Powered by<br/>{{ service.provider }}
                  </div>
                </div>
                <div class="col-8 pos-relative">
                  <div class="mb-4">
                    <div class="h4 mb-1">
                      {{ service.name }}
                    </div>
                    <div class="text-black mb-2" v-html="service.description">
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="service.price" class="product-price">
                <span v-if="service.price === 'pro' && service.price !== 'free'" class="badge badge-success">PRO Only</span>
                <span v-if="service.price !== 'pro' && service.price !== 'free'" class="badge">
                  <span v-if="!user.subscription || (user.subscription && !service.pro_price)">
                    {{ service.price }}
                  </span>
                  <span v-if="user.subscription && service.pro_price">
                    {{ service.pro_price }}
                  </span>
                </span>
                <span v-if="service.price === 'free'" class="badge">{{ $t('free') }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'

export default {
  name: 'ExtraTools',
  data: function () {
    return {
      categoryFilter: '',
      beta: true,
      stripe: {},
      services: [
        // {
        //   new: true,
        //   name: 'AI Beat Generator 🔥',
        //   description: this.$t('ai_beat_generator_description'),
        //   provider: 'Indiefy',
        //   category: 'audio',
        //   image: '/static/img/services/beat-generator.jpg',
        //   url: '/tools/beat-generator'
        // },
        {
          new: true,
          name: 'AI Cover Art Generator 🔥',
          description: this.$t('ai_cover_description'),
          provider: 'Indiefy',
          category: 'audio',
          image: '/static/img/services/cover-generator.jpg',
          url: '/tools/cover-generator'
        },
        {
          name: 'AI Lyric Generator',
          description: this.$t('lyric_generator_short_description'),
          price: 'free',
          category: 'tools',
          provider: 'Indiefy',
          image: '/static/img/services/lyric-generator.jpg',
          url: '/tools/lyric-generator'
        },
        {
          name: 'AI Mastering',
          description: this.$t('mastering_tool_description'),
          price: '$15.00',
          pro_price: '$4.99',
          provider: 'Dolby.io',
          category: 'audio',
          image: '/static/img/services/mastering.jpg',
          url: '/tools/mastering'
        },
        {
          name: this.$t('form_title'),
          description: this.$t('forms_description'),
          provider: 'Indiefy',
          category: 'forms',
          image: '/static/img/forms/forms.jpg',
          url: '/tools/forms'
        },
        {
          name: this.$t('banner_generator'),
          description: this.$t('banner_generator_description'),
          price: 'free',
          category: 'marketing',
          provider: 'Indiefy',
          image: '/static/img/services/banner-editor.jpg',
          url: '/tools/banners'
        },
        {
          name: 'Smartlinks',
          price: 'free',
          category: 'marketing',
          provider: 'Indiefy',
          description: this.$t('smartlink_description'),
          image: '/static/img/services/smartlink.jpg',
          url: '/tools/smartlinks'
        },
        {
          name: 'Pre-Save',
          description: this.$t('presave_details'),
          price: 'pro',
          category: 'marketing',
          provider: 'Indiefy',
          image: '/static/img/services/presave.jpg',
          url: '/presave-campaigns'
        },
        {
          name: this.$t('artist_website'),
          description: this.$t('website_tool_description'),
          price: 'free',
          category: 'marketing',
          provider: 'Indiefy',
          image: '/static/img/services/website.jpg',
          url: '/tools/websites'
        }
      ]
    }
  },
  computed: {
    filteredServices: function () {
      let services = this.services

      if (this.categoryFilter) {
        services = _.filter(this.services, item => {
          return item.category === this.categoryFilter
        })
      }

      return services
    }
  },
  methods: {
  },
  mounted: function () {
    setTimeout(() => {
      window.prerenderReady = true

      window.$('html, body').animate({
        scrollTop: 0
      }, 500)

      // eslint-disable-next-line
      // if (!this.user.subscription) {
      //   (window.adsbygoogle = window.adsbygoogle || []).push({})
      // }
    }, 500)
  },
  created: function () {
    this.user = this.$user
    this.stripe = window.Stripe('pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm')

    window.document.title = this.$t('services_title') + ' | Indiefy'
    window.$('meta[name="description"]').attr('content', this.$t('services_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('services_description'))

    if (this.$route.query.beta) {
      this.beta = true
    }
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
.service-description {
  min-height: 90px;
}

.line-through {
  font-size: 12px;
}

.list-group-item {
  display: block !important;
}

.card img {
  border-radius: 3px;
}

.product-price {
  position: absolute;
  bottom: 13px;
  right: 15px;
}

.product-price span {
  font-size: 16px;
}

.new {
  position: absolute;
  top: -4px;
  right: -4px;
}
</style>



// WEBPACK FOOTER //
// src/components/ExtraTools.vue